function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import PropTypes from "prop-types";
import { get, isEmpty } from "lodash";
import { compose } from "recompose";
import { Banner, withSnackbar } from "@dpdgroupuk/mydpd-ui";
import { SubmissionError } from "redux-form";
import { BANNERS_TYPES, ERROR_TYPE } from "@dpdgroupuk/mydpd-enums";
import Context from "./Context";
import { getErrorMessage, isIgnoredError, defaultErrorMapper, getValidFieldErrors } from "./utils";
import { SHOW_ALERT_DISPLAY_TIME } from "./constants";
const defaultBlackList = [SubmissionError.name, "AbortError"];

class Provider extends React.Component {
  constructor(..._args) {
    super(..._args);

    _defineProperty(this, "showError", (error, options) => {
      if (typeof options === "string") {
        options = {
          entityName: options
        };
      }

      options = {
        blackList: this.props.blackList,
        mapErrors: this.props.mapErrors,
        ...options
      };
      if (isIgnoredError(error)) return;
      const errorCode = get(error, "errors[0].code");

      switch (errorCode) {
        case ERROR_TYPE.APPLICATION:
          {
            return this.props.snackbar.showAlert({
              message: getErrorMessage(error, options.entityName),
              displayTime: this.props.snackbarDisplayTime
            });
          }

        case ERROR_TYPE.BUSINESS_RULE:
          return this.props.banner.showByType(BANNERS_TYPES.ALERT, {
            message: getErrorMessage(error, options.entityName),
            closable: true,
            showIcon: true,
            actions: []
          });

        case ERROR_TYPE.FIELD_VALIDATION:
          {
            const mappedErrors = options.mapErrors(getValidFieldErrors(get(error, "errors")));

            if (!isEmpty(mappedErrors)) {
              throw new SubmissionError(mappedErrors);
            } else {
              throw error;
            }
          }

        default:
          {
            if (!options.blackList.includes(error.name)) {
              return this.props.snackbar.showAlert({
                message: getErrorMessage(error, options.entityName),
                displayTime: this.props.snackbarDisplayTime
              });
            } else {
              throw error;
            }
          }
      }
    });

    _defineProperty(this, "runAsync", (func, options) => async (...args) => {
      try {
        return await Promise.resolve(func(...args));
      } catch (error) {
        this.showError(error, options);
      }
    });

    _defineProperty(this, "scrollToError", error => {
      const errorsList = Array.isArray(error) ? error : Object.keys(error); // If no errors to display, then exit

      if (errorsList.length === 0) return false; // Else spot the first error elements at the page and select it

      const queryElement = id => document.querySelector(`[id$="${id}"]`) || document.querySelector(`[name$="${id}"]`);

      const errorsListSorted = errorsList.map(queryElement).filter(Boolean);

      if (errorsListSorted.length > 1) {
        errorsListSorted.sort((a, b) => a.getBoundingClientRect().x + a.getBoundingClientRect().y - (b.getBoundingClientRect().x + b.getBoundingClientRect().y));
      }

      const target = errorsListSorted?.[0]; // If nothing found, then nothing to do

      if (!target) return false;
      const mainBody = document.querySelector(".mydpd-main-body");
      const mainBodyScrollTop = mainBody?.scrollTop;
      const elementTopPosition = target?.getBoundingClientRect().top;
      const headerHeight = mainBody?.getBoundingClientRect().top;
      const bannersHeight = document.querySelector(".banner-absolute-container")?.getBoundingClientRect().height;
      const offset = 15; // offset from top

      mainBody.scrollTo(0, mainBodyScrollTop + elementTopPosition - bannersHeight - headerHeight - offset);
      return true;
    });
  }

  render() {
    return /*#__PURE__*/React.createElement(Context.Provider, {
      value: {
        runAsync: this.runAsync,
        scrollToError: this.scrollToError,
        showError: this.showError
      }
    }, this.props.children);
  }

}

Provider.propTypes = {
  children: PropTypes.node,
  blackList: PropTypes.array,
  mapErrors: PropTypes.func,
  banner: PropTypes.object,
  snackbar: PropTypes.object,
  snackbarDisplayTime: PropTypes.number
};
Provider.defaultProps = {
  blackList: defaultBlackList,
  snackbarDisplayTime: SHOW_ALERT_DISPLAY_TIME,
  mapErrors: defaultErrorMapper
};
export default compose(withSnackbar, Banner.withBanner)(Provider);